import React from "react";

import "./styles.css";
import Logo from "../logo";
import User from "../user";

const Navbar = () => {
  return (
    <header id="main-header">
      <a id="header-left" href="/">
        <Logo />

        <span id="title-text">Zo Supply</span>
      </a>
      <div id="header-center"></div>
      <div id="header-right">
        <User />
      </div>
    </header>
  );
};

export default Navbar;
